export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";